import React from "react";
import AIAlertsMobileLogo from "../../assets/images/ai-alerts/mobile-logo.png";
import PhoneMockup from "../../assets/images/ai-alerts/phone-mockup.png";
import { AppStoreIcon, GooglePlayIcon } from "../common/Icon/AIAlerts";

const AIAlertsMobileView = () => {
  return (
    <div className="ai-alerts-mobile-view">
      <div className="mobile-view-content">
        <div className="mobile-app-icon">
          <img src={AIAlertsMobileLogo} alt="AI Options Alerts" />
        </div>
        <h2 className="mobile-title">
          Download TradeAlgo now to
          <br />
          access AI Options Alerts
        </h2>
        <div className="mobile-badges">
          <a
            href="https://apps.apple.com/sg/app/tradealgo-ai/id6741116698"
            target="_blank"
            rel="noopener noreferrer"
            className="badge-link"
          >
            <AppStoreIcon />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.tafintech.tradealgo.app&hl=en&pli=1"
            target="_blank"
            rel="noopener noreferrer"
            className="badge-link"
          >
            <GooglePlayIcon />
          </a>
        </div>
        <div className="mobile-phone-mockup">
          <img src={PhoneMockup} alt="TradeAlgo App" />
        </div>
      </div>
    </div>
  );
};

export default AIAlertsMobileView;
